<template>
  <rect
    :x = "getTrimX"
    :y = 0
    :width = "1"
    :height = "getTrimHFull"
    opacity = ".85"
    fill = "red"
  />
  <rect
    :x = "getTrimX"
    :y = "getTrimY"
    :width = "Math.max(getTrimW * getMagScale, 0)"
    :height = "getTrimH"
    opacity = ".85"
    fill = "red"
    @click.stop = "handleTrimClick"
    @contextmenu.stop = ""
    class = "trim-area"
  />
  <text
    :x = "getTrimX + 10"
    :y = "getTrimY + 18"
    class = "trim-text"
  >
    TRIM
  </text>
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';

export default {
  name: 'Trim',
  mounted () {
    useSegmentStore().setTrimFunc(this.handleTrimClick);
  },
  computed: {
    getAllPipesLength () {
      return useSegmentStore().getAllSegmentLengths('pipe');
    },
    getPipeEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getTrimX () {
      return (this.getAllPipesLength * this.getMagScale) + useInputStore().getXAxisGap;
    },
    getTrimY () {
      return this.getPipeEditorHeight - 30;
    },
    getTrimW () {
      return useSegmentStore().getAllSegmentLengths('slope') - this.getAllPipesLength;
    },
    getTrimH () {
      return 30;
    },
    getTrimHFull () {
      return this.getPipeEditorHeight;
    }
  },
  methods: {
    handleTrimClick () {
      useSegmentStore().trimSlopes();
      useInputStore().sprinklerCalc();
    }
  }
};
</script>

<style scoped>
.trim-text {
  font-family: "Heebo", sans-serif;
  font-size: 65%;
  font-weight: bold;
  user-select: none;
  pointer-events: none;
  fill: white;
}
.trim-area {
  cursor:pointer;
}
</style>